<div class="item-page-field">
  <ds-metadata-values
    [mdValues]="item?.allMetadata(fields)"
    [separator]="separator"
    [label]="label"
    [toUpperCase]="toUpperCase"
  ></ds-metadata-values>
</div>
